import { VOBackground } from "../model/DataStructure.js";

export interface BackgroundOptions {
    container: HTMLElement;
    data?: VOBackground;
}

export class Background {
    private _element: HTMLDivElement;

    private _video: HTMLVideoElement;
    private _image: HTMLDivElement;
    private _color: HTMLDivElement;
    private _current: VOBackground = null;

    constructor(options: BackgroundOptions) {
        options = e5.object.merge({

        }, options);

        this._element = document.createElement("div");
        this._element.className = "background";
        this._element.innerHTML = `
        <div class="background__layer background__image" data-type="image"></div>
        <video class="background__layer background__video" data-type="video"></video>
        <div class="background__layer background__color" data-type="color"></div>
        `;

        this._video = this._element.querySelector(".background__video");
        this._image = this._element.querySelector(".background__image");
        this._color = this._element.querySelector(".background__color");

        this._video.muted = true;
        this._video.volume = 0;
        this._video.autoplay = true;
        this._video.loop = true;

        if (options.data) {
            this.load(options.data);
        }

        options.container.appendChild(this._element);
    }

    public load(data: VOBackground): void {
        this._current = data;

        
        let type = data?.background_type || "none";

        if(type !== "video"){
            this._video.pause();
        }

        this._element.querySelectorAll(".background__layer[data-type]")
        .forEach((e) => {
            e.classList.toggle("background__layer--active", type == e.getAttribute("data-type"));
        });

        if (type === "none") {

        } else if (type === "image") {
            this._image.style.backgroundImage = `url(${data.background_image.url})`;
        } else if (type === "video") {
            this._video.src = data.background_video.url;
            this._video.play();
        } else if (type === "color") {
            this._color.style.backgroundColor = data.background_color;
        }
    }
}